import { useState, useCallback } from 'react';

const STORAGE_KEY = 'navCollapsed';

// Whether the sidebar nav is folded down to its icons. Kept in localStorage
// so it survives reloads and route changes — each route mounts its own
// <Layout>, so state held only in React would reset on every navigation.
export function useNavCollapsed() {
    const [collapsed, setCollapsed] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });

    const toggleCollapsed = useCallback(() => {
        setCollapsed(prev => {
            try {
                localStorage.setItem(STORAGE_KEY, String(!prev));
            } catch {
                // Storage blocked (private mode): the toggle still works for this page.
            }
            return !prev;
        });
    }, []);

    return { collapsed, toggleCollapsed };
}
